import React from 'react'

const RemoveItem = props => (
  <svg width={14} height={14} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14A7 7 0 107 0a7 7 0 000 14zM4.172 4.172a.5.5 0 000 .707L6.292 7l-2.12 2.121a.5.5 0 00.707.707L7 7.708l2.121 2.12a.5.5 0 10.707-.707L7.708 7l2.12-2.121a.5.5 0 10-.707-.707L7 6.292l-2.121-2.12a.5.5 0 00-.707 0z"
      fill="#EE4360"
    />
  </svg>
)

export default RemoveItem



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/removeItem.js